import styled, { keyframes } from "styled-components";
import { Card } from "../../../components";

export const rippleEffect = keyframes`
  to {
    transform: scale(4);
    opacity: 0;
  }
`;

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {}

export const StyledCard = styled(Card)<CardProps>`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.sm};
  gap: ${({ theme }) => theme.spacing.sm};
  border-radius: ${({ theme }) => theme.radii.lg};
  background: ${({ theme }) => theme.colors.surface};
  transition: background 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.surfaceHover};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: row;
    align-items: flex-start;
    padding: ${({ theme }) => theme.spacing.sm};
    gap: ${({ theme }) => theme.spacing.xs};
  }
`;

export const CardWrapper: React.FC<CardProps> = ({ children, ...rest }) => {
  return <StyledCard {...rest}>{children}</StyledCard>;
};

export const Ripple = styled.span`
  position: absolute;
  width: 100px;
  height: 100px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  transform: scale(0);
  opacity: 0.75;
  pointer-events: none;
  z-index: 0;
  transition: transform 0.6s ease-out, opacity 0.6s ease-out;

  &.ripple {
    transform: scale(3);
    opacity: 0;
  }
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  z-index: 1;
`;

export const HeaderLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const XP = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.success};
  font-weight: bold;
`;

export const MetaLine = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-top: ${({ theme }) => theme.spacing.xs};
`;